import type {TooltipAttrs} from '@jetbrains/ring-ui-built/components/tooltip/tooltip'
import RingTooltip from '@jetbrains/ring-ui-built/components/tooltip/tooltip'

export default function Tooltip(props: TooltipAttrs) {
  return (
    <RingTooltip
      {...props}
      popupProps={{
        top: 0,
        offset: 4,
        ...props.popupProps,
      }}
    />
  )
}
